const GenderEnum = Object.assign({
  MALE: { name: 'Male', value: 'male' },
  FEMALE: { name: 'Female', value: 'female' },
});

Object.freeze(GenderEnum);

function getEnumAsArray() {
  return Object.keys(GenderEnum)
    .map(key => ({
      name: GenderEnum[key].name,
      value: GenderEnum[key].value,
    }));
}

export const genderArray = getEnumAsArray();

export default GenderEnum;



// WEBPACK FOOTER //
// ./src/enum/user/Gender.js